import { apiGet } from '../helpers/ApiHelper';
import Auth from 'j-toker';

export function todoList(response) {
  return {
    type: 'TODOS::SHOW_TODO_LIST',
    todoData: response.todoData,
    numberOfTasks: response.numberOfTodos,
  };
}

export function getTenantTodoList() {
  let route = '/leads/todos';
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + route)
        .then(response => {
          dispatch(todoList(response));
        })
        .catch(err => {}),
    });
  };
}
